









































import BaseComponent from '@/components/base-component.vue';
import UiRadioGroupsClinicStates from '@/components/simple-therapy/radiogroup-clinic-states.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { getUserActivationHist } from '@/services/users';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import StarRating from 'vue-star-rating'

@Component({
  components: {
    ListMessages,
    UiRadioGroupsClinicStates,
    StarRating
  },
})
export default class UserActivationHist extends BaseComponent {
  @Prop()
  public id;

  dialogFlag = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Data', value: 'data', align: 'center', sortable: false },
    { text: 'Alterado por', value: '', align: 'left', sortable: false },
    { text: 'Ação', value: 'açao', align: 'center', sortable: false },
    { text: 'Motivo', value: 'motivo', align: 'left', sortable: false },
    { text: 'Avaliação do sistema', value: 'notaAvalSistema', align: 'left', sortable: false },
  ];

  loading = false;
  error = false;
  items = [];

  mounted() {
    this.dialogFlag = true;
    this.load();
  }

  load() {
    this.loading = true;
    this.error = false;
    getUserActivationHist(this.id).subscribe(
      (res) => {
        this.items = res;
        this.loading = false;
        this.error = false;
      },
      (error) => {
        this.loading = false;
        this.error = true;
        this.showToastApiError(error);
      },
    );
  }

  closeForm() {
    this.$emit('close');
  }
}
